export default __webpack_public_path__ + "static/achieve-soc2-compliance-saas-growth-71de47cd20d71a74abf5c8bb099bca5a.png";